import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../guards/auth.guard';
import { EndOfDayComponent } from './end-of-day.component';

const routes: Routes = [
  { path: '', component: EndOfDayComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EndOfDayRoutingModule { }
